<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="直播" name="first">
      <div style="width: 100%" class="draggable-tableaaa">
        <div style class="draggable-table">
          <div class="answer bor" style="width: 20%">直播名</div>
          <div class="answer bor" style="width: 40%">直播类型</div>
          <div class="answer bor" style="width: 20%">授课老师</div>
          <div class="delete bor" style="width: 10%">开始时间</div>
          <div class="answer bor" style="width: 10%">结束时间</div>
          <!-- <div class="delete bor" style="width: 10%">操作</div> -->
        </div>
        <draggable
          v-if="data.length"
          v-model="data"
          @update="datadragEnd"
          :options="{ animation: 500 }"
        >
          <div v-for="(element, index) in data" :key="index" class="drag-item">
            <div class="draggable-table">
              <el-tooltip
                :open-delay="500"
                class="item"
                effect="dark"
                :content="element.liveName"
              >
                <div style="width: 20%" class="answer">
                  {{ element.liveName || "null" }}
                </div>
              </el-tooltip>
              <div
                v-if="element.liveType == 1"
                style="width: 40%"
                class="answer"
              >
                保利威
              </div>
              <div
                v-if="element.liveType == 2"
                style="width: 40%"
                class="answer"
              >
                小鹅通
              </div>
              <div
                v-if="element.liveType == 3"
                style="width: 40%"
                class="answer"
              >
                民生
              </div>
              <div style="width: 20%" class="answer">
                {{ element.liveTeacherName || "暂无" }}
              </div>
              <div style="width: 10%" class="answer">
                {{ element.liveBeginTime || "暂无" }}
              </div>
              <div style="width: 10%" class="answer">
                {{ element.liveEndTime || "暂无" }}
              </div>
              <!-- <div style="width: 10%" class="delete">
                <span
                  style="margin-left: 30px"
                  class="mainColor"
                  @click="editLive(element)"
                >
                  编辑
                </span>
              </div> -->
            </div>
          </div>
        </draggable>
        <div
          v-else
          style="
            text-align: center;
            line-height: 60px;
            color: #909399;
            border-bottom: 1px solid #ebeef5;
            border-right: 1px solid #ebeef5;
          "
        >
          暂无数据
        </div>
      </div>
    </el-tab-pane>
    <el-tab-pane label="直播回放" name="second">
      <div style="width: 100%" class="draggable-tableaaa">
        <div style class="draggable-table">
          <div class="answer bor" style="width: 20%">所属课程</div>
          <div class="answer bor" style="width: 40%">名称</div>
          <div class="answer bor" style="width: 10%">授课老师</div>
          <div class="delete bor" style="width: 10%">版本号</div>
          <div class="answer bor" style="width: 10%">类型</div>
          <div class="delete bor" style="width: 10%">操作</div>
        </div>
        <draggable
          v-if="page.rows.length"
          v-model="page.rows"
          @update="datadragEnd"
          :options="{ animation: 500 }"
        >
          <div
            v-for="(element, index) in page.rows"
            :key="index"
            class="drag-item"
          >
            <div class="draggable-table">
              <el-tooltip
                :open-delay="500"
                class="item"
                effect="dark"
                :content="element.courseName"
              >
                <div style="width: 20%" class="answer">
                  {{ element.courseName || "null" }}
                </div>
              </el-tooltip>
              <el-tooltip
                :open-delay="500"
                class="item"
                effect="dark"
                :content="element.name"
              >
                <div style="width: 40%" class="answer">
                  {{ element.name || "null" }}
                </div>
              </el-tooltip>
              <div style="width: 10%" class="answer">
                {{ element.teacher || "暂无" }}
              </div>
              <div style="width: 10%" class="answer">
                {{ element.version || "暂无" }}
              </div>
              <div style="width: 10%" class="answer">
                <span>{{ element.type || "null" }}</span>
                <div v-if="element.powerList" style="display: inline">
                  <span class="line"></span>
                  <el-popover trigger="click" v-model="element.isPrpover">
                    <el-checkbox-group v-model="checkList">
                      <el-checkbox
                        v-for="(item, index) in powerList"
                        :key="index"
                        :label="item.power"
                        >{{ item.name }}</el-checkbox
                      >
                    </el-checkbox-group>
                    <el-button
                      size="mini"
                      type="primary"
                      class="type-btn"
                      @click="sunmitType(element)"
                      >提交</el-button
                    >
                    <span slot="reference" @click="rangeCli(element)"
                      >范围<i class="el-icon-arrow-down el-icon--right"></i
                    ></span>
                  </el-popover>
                </div>
              </div>
              <div style="width: 10%" class="delete">
                <el-popconfirm
                  confirm-button-text="确定"
                  cancel-button-text="取消"
                  icon="el-icon-info"
                  icon-color="red"
                  @confirm="deleteGoodsItem(element.id)"
                  title="确定解绑吗？"
                >
                  <el-button type="text" slot="reference">解绑</el-button>
                </el-popconfirm>
              </div>
            </div>
          </div>
        </draggable>
        <div
          v-else
          style="
            text-align: center;
            line-height: 60px;
            color: #909399;
            border-bottom: 1px solid #ebeef5;
            border-right: 1px solid #ebeef5;
          "
        >
          暂无数据
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "liveComponent",
  components: { draggable },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    id: {
      type: String,
      default: "",
    },
    page: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      searchForm: {},
      activeName: "first",
    };
  },
  methods: {
    handleClick({ index }) {
      if (index == "0") {
        this.$emit("getData");
      } else {
        this.pageList();
      }
    },
    deleteGoodsItem(vId) {
      this.api.goodsItem.deleteGoodsItem([{ id: vId }]).then((result) => {
        this.pageList();
        this.$message.success("解绑成功");
      });
    },
    pageList(type) {
      console.log(this.page, 33);
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.goodsId = this.id;
      this.searchForm.type = "录播";
      this.api.goodsItem
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    datadragEnd(evt) {
      console.log(evt);
      let arr = [];
      this.data.forEach((item, index) => {
        arr.push({
          id: item.id,
          sort: index + 1,
        });
      });
      console.log(arr);
      this.api
        .changeSort(arr)
        .then((result) => {
          this.$message.success(result.message);
        })
        .catch((error) => {
          console.log(error);
        });
      evt.preventDefault();
    },
  },
};
</script>
<style lang="less" scoped>
.draggable-tableaaa {
  margin-top: 20px;
  border-top: 1px solid #d9ebf5;
  border-left: 1px solid #d9ebf5;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  .bor {
    font-weight: bolder;
    color: #4e4e4e;
    background-color: rgb(250, 250, 250) !important;
  }
  .draggable-table {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      padding: 8px 10px;
      font-size: 12px;
      line-height: 23px;
    }
    .htmltittles {
      white-space: nowrap;
      padding: 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      img {
        display: none !important;
      }
      p {
        font-size: 12px !important;
        line-height: 23px !important;
        margin: 0px !important;
        color: #606266 !important;
        white-space: nowrap !important;
        img {
          display: none !important;
        }
      }
    }
    .title {
      width: 60%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .state {
        padding: 0;
        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      .questionTypeName {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      white-space: nowrap;
    }
    .answer {
      width: 22%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .delete {
      width: 12%;
      cursor: pointer;
      border-bottom: 1px solid #d9ebf5;
      text-align: center;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.avatar-uploader-logo {
  margin-right: 30px;
  .avatar {
    width: 56px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    border-radius: 50%;
    background-color: #f8f8f8;
    border: 1px dashed #333;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/goods/liveComponent.vue